import React, { useContext, useEffect, useState } from 'react';
import { Card, Col, Row, OverlayTrigger, Modal, Popover, Button, Form, Spinner, InputGroup } from 'react-bootstrap';

import { useContextInfo } from '../../../context/ContextInfo';
import { AuthContext } from '../../../auth/AuthContext';
import icoFib from '../../../images/icofiber.png';
import moment from 'moment';
import BadOtros from '../../../pages/finanzas/pago/BadOtros';
import BadgetInternet from '../../../pages/finanzas/pago/BadgetInternet';
import BadCarSal from '../../../pages/finanzas/pago/BadCarSal';
import { useForm } from '../../../hooks/useForm';
import { fetchConToken } from '../../../api/fetch';
import classNames from 'classnames';
import { BsCurrencyDollar } from 'react-icons/bs';
const initialState = { meses: 0, forma_pago: '', folio: '', pagado: '', fecha_pago: '', total: '' };
const ModEdItPay = ({ show, onClose, data, callBk, sat }) => {
    const { setResp } = useContextInfo();
    const [meses, setMeses] = useState(0);
    const [total, setTotal] = useState('');
    const [folEx, setFolEx] = useState(false);
    const [bon, setBon] = useState(0);
    const [fecha, setfecha] = useState('');
    const setPlan = (pl) => setPinfo(pl);
    const [send, setSend] = useState(false);
    const [validated, setValidated] = useState(false);
    const [pinfo, setPinfo] = useState({});
    const { auth } = useContext(AuthContext);
    const { cargos = [], saldos = [], datos = {}, otros = [], pago = {}, tipo = {}, speed = {}, planes = [] } = data;
    const {
        estado = '',
        fechapago = '',

        nombre = '',

        tlcargo = 0, //!cargos tl
        tlsaldo = 0, //!saldos tl
    } = datos;
    const { costo } = pinfo;
    const [values, handleInputChange, reset, setFormValue] = useForm({
        forma_pago: 'Efectivo Oficina/Sucursal',
        folio: '',
        pagado: '',
        saldo: '',
        cargo: '',
        subtotal: '',
        fecha_pago: '',
        fecha_corte: '',
        nota: '',
    });
    const { pagado = '', saldo = '', cargo = '', forma_pago = 'Efectivo Oficina/Sucursal' } = values;
    useEffect(() => {
        setPinfo(speed);
    }, [speed]);
    useEffect(() => {
        forma_pago !== 'Efectivo Oficina/Sucursal' && forma_pago !== 'Efectivo Oficina/Sucursal 5512'
            ? setFolEx(true)
            : setFolEx(false);
    }, [forma_pago]);

    useEffect(() => {
        processTl();
    }, [meses, costo]);
    useEffect(() => {
        setTotal(total - bon);
    }, [bon]);
    useEffect(() => {
        if (parseFloat(pagado) == parseFloat(total)) {
            setFormValue({
                saldo: 0,
                pagado: parseFloat(pagado),
                cargo: 0,
                ...values,
            });
        }
        if (pagado > total) {
            let sal = pagado - total;
            setFormValue({
                ...values,
                pagado: parseFloat(pagado),
                saldo: parseFloat(sal),
                cargo: 0,
            });
        }
        if (pagado < total) {
            let car = total - pagado;
            setFormValue({
                ...values,
                pagado: parseFloat(pagado),
                saldo: 0,
                cargo: parseFloat(car),
            });
        }
    }, [pagado]);
    useEffect(() => {
        setFormValue({
            ...values,
            pagado: total,
        });
    }, [total, costo, show]);
    useEffect(() => {
        processP();
    }, [pago]);
    useEffect(() => {
        totalAdd();
    }, [meses, fechapago]);
    const processP = () => {
        let meses = 0;
        let forma_pago = 'Efectivo Oficina/Sucursal';
        let folio = '';
        let pagado = '';
        let fecha_pago = '';
        let total = '';
        if (pago) {
            meses = pago?.meses;
            forma_pago = pago?.forma_pago;
            folio = pago?.folio;
            pagado = pago?.pagado;
            fecha_pago = pago?.fecha_pago;
            total = pago?.total;
        }
        setTotal(total);
        setMeses(meses);
        let fec = moment(fecha_pago).format('YYYY-MM-DD');
        setFormValue({
            ...values,
            fecha_pago: fec,
            fecha_corte: pago?.fecha_corte,
            forma_pago,
            folio,
            pagado: parseFloat(pagado),
        });
    };
    const totalAdd = () => {
        let ms = parseInt(meses);
        let mesesa = 0;
        let fecha_cortea = '';
        let fecha_proxa = '';
    
        if (pago) {
            mesesa = pago?.meses;
            fecha_cortea = pago?.fecha_corte;
            fecha_proxa = pago?.fecha_prox;
        }
    
        if (meses == mesesa) {
            setfecha(fecha_proxa);
        } else {
            let nuevaFecha = moment(fecha_cortea).add(ms, 'M'); // Sumamos los meses
            const diaOriginal = moment(fecha_cortea).date();
    
            // Si la nueva fecha cae en febrero y el día original era 30 o 31, lo cambia a 1 de marzo
            if (nuevaFecha.month() === 1) { // 1 = Febrero en Moment.js
                const maxDiaFebrero = nuevaFecha.daysInMonth(); // 28 o 29 dependiendo del año
                
                if (diaOriginal > maxDiaFebrero || (diaOriginal === 29 && maxDiaFebrero === 28)) {
                    nuevaFecha = nuevaFecha.date(1).month(2); // Cambia al 1 de marzo
                }
            }
    
            // Formateamos la fecha corregida
            const day = nuevaFecha.format('YYYY-MM-DD');
            setfecha(day);
        }
    
        setBon(0);
        if (ms === 12) setBon(costo);
    };
    
    const processTl = () => {
        let pa = tlcargo - tlsaldo;
        let subInternet = meses * costo;
        let sumOt = 0;
        for (const key in otros) {
            if (Object.hasOwnProperty.call(otros, key)) {
                const element = otros[key];
                if (element.dias > 0) {
                    sumOt = sumOt  + meses * element.precio;
                } else {
                    sumOt = parseInt(sumOt) + parseInt(element.precio) * meses;
                }
            }
        }
        const totalPay = sumOt + subInternet + pa - bon;
        setTotal(totalPay);
    };
    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        if (send) return;
        setSend(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let car = values.cargo;
            let sal = values.saldo;
            if (parseFloat(total) == parseFloat(values.pagado)) {
                car = 0;
                sal = 0;
            }

            let res = await fetchConToken(
                `factura/editpay`,
                {
                    ...values,
                    cargo: car,
                    id: data.id,
                    saldo: sal,
                    id_a: auth.uid,
                    bon,
                    detalle: pinfo.descripcion,
                    total,
                    fechapago: fecha,
                    meses,
                    plan: pinfo,
                },
                'PUT'
            );
            setResp(res);
            if (res.ok) {
                callBk();
                onClose();
                reset();
                setfecha('');
                setMeses(0);
                setFolEx(false);
                setTotal('');
                setBon(false);
            }
        }
        setSend(false);
    };
    return (
        <Modal centered show={show} onHide={onClose} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Editar pago </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    {show && (
                        <Card className="p-2">
                            <Row>
                                <Col>
                                    <div className="d-flex flex-row mb-3">
                                        <span className="">
                                            {tipo === 'FIBRA' ? (
                                                <img src={icoFib} alt="fiber" width="18px" />
                                            ) : (
                                                <i className="mdi mdi-wifi  mdi-24px text-primary  "></i>
                                            )}
                                        </span>{' '}
                                        <div className="text-uppercase mr-2 p-2">
                                            {nombre}{' '}
                                            <span
                                                className={classNames('badge', {
                                                    'bg-success': estado === 'ACTIVO',
                                                    'bg-danger': estado === 'SUSPENDIDO',
                                                })}>
                                                {estado}
                                            </span>
                                        </div>
                                    </div>{' '}
                                </Col>
                                <Col>
                                    <b className="mx-2 text-12"> Plan Actual</b>
                                    <span className={classNames('badge bg-primary')}> {pinfo.plan}</span>
                                </Col>
                                <Col>
                                    <OverlayTrigger
                                        trigger="click"
                                        placement="left"
                                        overlay={
                                            <Popover>
                                                <Popover.Header as="h3" className="text-center">
                                                    Planes <br />
                                                    <span className="text-info">
                                                        (El cambio se relizara segun la fecha de corte)
                                                    </span>
                                                </Popover.Header>

                                                <Popover.Body>
                                                    <div className="row row-cols-2">
                                                        {planes.map((us, i) => (
                                                            <div className="col" key={i + 'bgol'}>
                                                                {!us.disabled && (
                                                                    <button
                                                                        key={us.id}
                                                                        type="button"
                                                                        style={{ fontSize: '11px', width: '125px' }}
                                                                        onClick={() => setPlan(us)}
                                                                        className={`btn mb-1 ${
                                                                            speed.id === us.id
                                                                                ? 'btn-success'
                                                                                : 'btn-light'
                                                                        } rounded-lg text-9 px-2 py-1.5 text-center font-bold inline-flex items-center   m-0.5`}>
                                                                        <i className="mdi mdi-wifi  text-primary  "></i>

                                                                        {us.nombre || us.plan}
                                                                    </button>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Popover.Body>
                                            </Popover>
                                        }
                                        rootClose={false}>
                                        <Button>Cambiar Plan</Button>
                                    </OverlayTrigger>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <BadgetInternet
                                        plan={pinfo.plan}
                                        descripcion={pinfo.descripcion}
                                        costo={pinfo.costo}
                                        meses={meses}
                                        total={meses * pinfo.costo}
                                    />
                                </Col>

                                <Col>
                                    {' '}
                                    <BadOtros otros={otros} meses={meses} />
                                </Col>
                                <Col>
                                    {' '}
                                    {bon > 0 && (
                                        <span className="text-white p-2 rounded " style={{ background: '#0990bb' }}>
                                            Bonificacion de 1 mes por pago anual ${bon}
                                        </span>
                                    )}{' '}
                                </Col>
                            </Row>
                            <BadCarSal cargos={cargos} saldos={saldos} />

                            <Row>
                                <Form noValidate validated={validated} onSubmit={onSubmit}>
                                    <Row>
                                        <Col>
                                            {' '}
                                            <Row>
                                                <Col xs={10}>
                                                    <Form.Group className="mb-3" controlId="validationCustomrp1">
                                                        <Form.Label>Forma de pago</Form.Label>
                                                        <Form.Select
                                                            value={values.forma_pago}
                                                            name="forma_pago"
                                                            required
                                                            onChange={handleInputChange}>
                                                            <option value="Efectivo Oficina/Sucursal">
                                                                Efectivo Oficina/Sucursal
                                                            </option>

                                                            <option value="Deposito bancario">Deposito bancario</option>
                                                            <option value="Trasferencia bancaria">
                                                                Trasferencia bancaria
                                                            </option>
                                                            <option value="Deposito bancario 5512">
                                                                Deposito bancario 5512
                                                            </option>
                                                            <option value="Trasferencia bancaria 5512">
                                                                Trasferencia bancaria 5512
                                                            </option>

                                                            <option value="Oxxo">Oxxo</option>
                                                            <option value="Mercado pago">Mercado pago</option>
                                                            <option value="PayPal/Visa/Mastercard">
                                                                PayPal/Visa/Mastercard
                                                            </option>
                                                            <option value="OpenPay">OpenPay</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group className="mb-3" controlId="validationCustomrp2">
                                                        <Form.Label>Meses {meses}</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            min={1}
                                                            max={12}
                                                            required
                                                            value={meses}
                                                            name="meses"
                                                            onChange={(e) => setMeses(e.target.value)}
                                                        />
                                                        <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                                    </Form.Group>{' '}
                                                </Col>{' '}
                                            </Row>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustomrp3">
                                                    <Form.Label>Numero de trasacción</Form.Label>
                                                    <Form.Control
                                                        required={folEx}
                                                        type="number"
                                                        value={values.folio}
                                                        name="folio"
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                                </Form.Group>{' '}
                                            </Col>{' '}
                                            <Row>
                                                <Col>
                                                    <Form.Group className="mb-3" controlId="validationCustomrp4">
                                                        <Form.Label> Fecha corte</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            value={values.fecha_corte}
                                                            name="fecha_corte"
                                                            onChange={handleInputChange}
                                                        />
                                                        <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                                    </Form.Group>{' '}
                                                </Col>{' '}
                                                <Col>
                                                    <Form.Group className="mb-3" controlId="validationCustomrp4">
                                                        <Form.Label>Proximo pago</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            value={fecha}
                                                            disabled
                                                            onChange={(e) => setfecha(e.target.value)}
                                                        />
                                                        <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                                    </Form.Group>{' '}
                                                </Col>{' '}
                                                <Col>
                                                    <Form.Group className="mb-3" controlId="validationCustomrp4">
                                                        <Form.Label> Fecha de pago</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            value={values.fecha_pago}
                                                            name="fecha_pago"
                                                            onChange={handleInputChange}
                                                        />
                                                        <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                                    </Form.Group>{' '}
                                                </Col>{' '}
                                            </Row>
                                            <Row>
                                                <Form.Group className="mb-3" controlId="validationCustomrp5">
                                                    <Form.Label>Notas</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        type="text"
                                                        value={values.nota}
                                                        name="nota"
                                                        onChange={handleInputChange}
                                                    />
                                                </Form.Group>{' '}
                                            </Row>
                                        </Col>
                                        <Col>
                                            <Row>
                                                <Col className="mt-3">
                                                    <div className="alert alert-success" role="alert">
                                                        TOTAL <span className="alert-link">${total}</span>
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <Form.Group controlId="validationCustomrp6">
                                                        <Form.Label
                                                            className={`fw-bold ${
                                                                pagado < total ? 'text-danger' : 'text-black'
                                                            }`}>
                                                            Total a pagar
                                                        </Form.Label>
                                                        <InputGroup hasValidation>
                                                            <InputGroup.Text id="inputGroupPrepend">
                                                                <BsCurrencyDollar />
                                                            </InputGroup.Text>
                                                            <Form.Control
                                                                type="number"
                                                                min={0}
                                                                className={`fw-bold ${
                                                                    pagado < total
                                                                        ? 'boder border-danger'
                                                                        : 'boder border-success'
                                                                }`}
                                                                required
                                                                name="pagado"
                                                                onChange={handleInputChange}
                                                                value={values.pagado}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                Ingrese una cantidad a pagar
                                                            </Form.Control.Feedback>{' '}
                                                        </InputGroup>
                                                    </Form.Group>
                                                </Col>
                                            </Row>{' '}
                                            <Col>
                                                {pagado < total && (
                                                    <div
                                                        className="alert alert-danger d-flex align-items-center"
                                                        role="alert">
                                                        <div>
                                                            {' '}
                                                            <span className="font-medium">ERROR! </span>Esta ingresando
                                                            un monto menor al total de la factura
                                                        </div>
                                                    </div>
                                                )}
                                                {pagado > total && (
                                                    <div
                                                        className="alert alert-warning d-flex align-items-center"
                                                        role="alert">
                                                        <div>
                                                            {' '}
                                                            <span className="font-medium">Saldo a favor! </span>Esta
                                                            ingresando un monto mayor al total de la factura, si
                                                            registra el pago quedará un saldo a favor del cliente de $
                                                            {saldo}
                                                        </div>
                                                    </div>
                                                )}
                                            </Col>
                                        </Col>
                                    </Row>
                                    {sat && (
                                        <div className="alert alert-warning" role="alert">
                                            <b>
                                                El pago contiene una factura eléctronica, si edita el pago (la
                                                cantidad,el metodo de pago) la factura se cancelara
                                            </b>
                                            <p>
                                                Factura: Folio-{sat.folio} <br /> Razon: {sat.razon}
                                            </p>
                                        </div>
                                    )}
                                    {send ? (
                                        <Button color="primary" disabled>
                                            <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                            Procesando...
                                        </Button>
                                    ) : (
                                        <>
                                            {!sat ? (
                                                <Button
                                                    type="submit"
                                                    variant={pagado < total ? 'secondary' : 'primary'}
                                                    disabled={pagado < total ? true : false}>
                                                    Guardar cambios
                                                </Button>
                                            ) : (
                                                <>
                                                    {auth.roll !== 'Administrador' && (
                                                        <div className="alert alert-info" role="alert">
                                                            Consulte un administrador para editar el pago
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                            {auth.roll === 'Administrador' && sat && (
                                                <Button
                                                    type="submit"
                                                    variant={pagado < total ? 'secondary' : 'primary'}
                                                    disabled={pagado < total ? true : false}>
                                                    Guardar cambios
                                                </Button>
                                            )}
                                        </>
                                    )}
                                </Form>
                            </Row>
                        </Card>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ModEdItPay;
